import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Sale } from '../sales/models/sale';
import { MotNaoCompra } from 'src/app/settings/models/mot-nao-compra';
import { LeadsFilter } from 'src/app/charges-module/charges/models/leads-filter';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class LeadsService {
  constructor(private http: HttpClient) {}

  private _leadsFilter: LeadsFilter = {
    appointmentDate: { fromDate: null, toDate: null },
    createdAt: { fromDate: null, toDate: null },
    reasonNotBuyCode: null,
  } as LeadsFilter;

  get leadsFilter() {
    return this._leadsFilter;
  }

  set leadsFilter(val: LeadsFilter) {
    this._leadsFilter = val;
  }

  getLeads(cnpj: string): Observable<Sale[]> {
    if (cnpj === '') {
      return of();
    }

    let queryParams = '';
    const startAppointmentDate = this.leadsFilter.appointmentDate.fromDate;
    const endAppointmentDate = this.leadsFilter.appointmentDate.toDate;
    const reasonNotBuy = this.leadsFilter.reasonNotBuyCode;
    const startCreatedAt = this.leadsFilter.createdAt.fromDate;
    const endCreatedAt = this.leadsFilter.createdAt.toDate;

    if (startAppointmentDate && endAppointmentDate) {
      const start = moment(startAppointmentDate).format('YYYY-MM-DD');
      const end = moment(endAppointmentDate).format('YYYY-MM-DD');
      queryParams += `&startAppointmentDate=${start}&endAppointmentDate=${end}`;
    }

    if (reasonNotBuy) {
      queryParams += `&reasonNotBuy=${reasonNotBuy}`;
    }

    if (startCreatedAt && endCreatedAt) {
      const start = moment(startCreatedAt).format('YYYY-MM-DD');
      const end = moment(endCreatedAt).format('YYYY-MM-DD');
      queryParams += `&startCreatedAt=${start}&endCreatedAt=${end}`;
    }

    const url = `${environment.vendas}/leadpainel/${cnpj}?${queryParams.slice(1)}`;

    return this.http.get<Sale[]>(url).pipe(
      catchError(err => {
        console.error(err);
        return of([]);
      }),
      map((leads: Sale[]) =>
        leads.map(lead => {
          if (lead.data_agendamento) {
            lead.data_agendamento = moment(lead.data_agendamento).format('DD/MM/YYYY HH:mm');
          }
          return lead;
        })
      )
    );
  }

  getDash(cnpj: string): Observable<Sale[]> {
    if (cnpj === '') {
      return of();
    }

    const data = {
      cnpj,
    } as any;
    const startAppointmentDate = this.leadsFilter.appointmentDate.fromDate;
    const endAppointmentDate = this.leadsFilter.appointmentDate.toDate;
    const reasonNotBuy = this.leadsFilter.reasonNotBuyCode;
    const startCreatedAt = this.leadsFilter.createdAt.fromDate;
    const endCreatedAt = this.leadsFilter.createdAt.toDate;

    if (startAppointmentDate && endAppointmentDate) {
      const start = moment(startAppointmentDate).format('YYYY-MM-DD');
      const end = moment(endAppointmentDate).format('YYYY-MM-DD');
      data.startAppointmentDate = start;
      data.endAppointmentDate = end;
    }

    if (reasonNotBuy) {
      data.reasonNotBuy = reasonNotBuy;
    }

    if (startCreatedAt && endCreatedAt) {
      const start = moment(startCreatedAt).format('YYYY-MM-DD');
      const end = moment(endCreatedAt).format('YYYY-MM-DD');
      data.startCreatedAt = start;
      data.endCreatedAt = end;
    }

    return this.http.post<Sale[]>(`${environment.vendas}/v1/leads/dash`, data).pipe(catchError(err => of(err.error)));
  }

  getReasonNotBuy(cnpj: string): Observable<MotNaoCompra[]> {
    if (cnpj === '') {
      return of([]);
    }

    return this.http
      .get<MotNaoCompra[]>(environment.vendas + '/motnaocomp/' + cnpj)
      .pipe(catchError(err => of(err.error)));
  }
  getLead(cnpj: string, id: string): Observable<Sale> {
    if (cnpj === '' || id === '') {
      return of();
    }

    return this.http
      .get<Sale>(environment.vendas + '/leadpainel/' + cnpj + '/' + id)
      .pipe(catchError(err => of(err.error)));
  }
}
